import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import UserMenu from './UserMenu';
import { ReactNode } from 'react';
import { Gear } from 'react-bootstrap-icons';

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  subtitle?: string;
  allowBack?: boolean;
  fullWidth?: boolean;
  rightMenu?: ReactNode;
  showUserMenu?: boolean;
  sidebar?: ReactNode;
}

const Layout = ({
  subtitle = '',
  fullWidth,
  rightMenu,
  showUserMenu = true,
  sidebar,
  children,
}: LayoutProps) => {
  return (
    <div className="sm-layout">
      {/* Header */}
      <div className="sm-layout__header">
        {/* Decorative gears */}
        <div className="sm-layout__header-gear sm-layout__header-gear--left">
          <Gear size={80} className="sm-animate-gear" />
        </div>
        <div className="sm-layout__header-gear sm-layout__header-gear--right">
          <Gear size={60} className="sm-animate-gear sm-animate-gear--reverse" />
        </div>
        
        <Container fluid>
          <Row className="justify-content-center text-center py-3">
            <Col xs lg={fullWidth ? 12 : 10}>
              <Row className="align-items-center">
                <Col>
                  <h1 className="sm-layout__header-title">
                    ⚙ Story Motion ⚙
                  </h1>
                  {subtitle && (
                    <p className="sm-layout__header-subtitle">{subtitle}</p>
                  )}
                </Col>
                <Col xs="auto" className="d-flex align-items-center gap-3">
                  {rightMenu}
                  {showUserMenu && <UserMenu />}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        
        {/* Bottom decorative line */}
        <div className="sm-layout__header-line" />
      </div>

      {/* Content Area */}
      <div className="sm-layout__content-wrapper">
        {sidebar && (
          <div className="sm-layout__sidebar-wrapper">
            {sidebar}
          </div>
        )}
        <div className="sm-layout__main">
          <Container fluid className={fullWidth ? 'p-0' : 'p-4'}>
            {children}
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Layout;
